import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IResourceRes,IAddResourceNewReq } from './index.type';


const useAddResource = () => {
  const url = `/RTM/upload-single-file`;
  const method = 'POST';
  const headerContentType = "multipart/form-data"

  const { loading: addResourceLoading, makeApiCall } = useApi({ url, method,headerContentType });

  const addResource = async (formData:IAddResourceNewReq) => {
    const { response, error } = await makeApiCall<IAddResourceNewReq, IResourceRes>(formData);
    if (response?.status === 'success') {
     toast.success('Resource Added Successfully');
      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to add resource. Please verify the resource details and try again.');
      return { status: 'fail' };
    }
  };

  return {
    addResourceLoading,
    addResource,
  };
};

export default useAddResource;
